import { render, staticRenderFns } from "./lgactivityorders.vue?vue&type=template&id=44b13f89&"
import script from "./lgactivityorders.vue?vue&type=script&lang=js&"
export * from "./lgactivityorders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports